import { createStorageValue } from '@interhyp/platform-storage';
import { createValue } from '@interhyp/platform-value';
import { z } from 'zod';
import { mortgageIntentNamespace } from '../namespaces';
/* the equity that the user has available to bring into the mortgage-intent
 */
export const equityMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('equityMemory'),
    schema: z.number(),
});
export const equityStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('equity'),
    schema: z.number(),
    type: 'local',
});
